import { z } from "zod";
import type { TFunction } from "i18next";

export function createImportSchema({ t }: { t: TFunction }) {
    return z
        .object({
            employeeNumber: z.string().min(1, { message: t("required-employee-number") }),
            job: z.string().optional(),
            location: z.string().optional(),
            date: z.string().min(1, { message: t("required-date") }),
            startDate: z.string().min(1, { message: t("required-start-date") }),
            endDate: z.string().min(1, { message: t("required-end-date") }),
        })
        // allocated org-level groups are added dynamically as extra columns
        .catchall(z.string().optional());
}

export type ImportFormValues = z.infer<ReturnType<typeof createImportSchema>>;
